module.exports = __webpack_public_path__ + "static/media/noOrderImg.e5d23cf9.jpg";